import { maxHeight900 } from "themes/default/breakpoints"

export const styles = {
  header: {
    zIndex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    boxSizing: "border-box",
    pt: { xs: 1.5, md: 1, lg: 4 },
    px: { xs: 1.5, md: 1, lg: 4 },
    [maxHeight900]: {
      pt: 2,
    },
  },
  logo: {
    height: { xs: "8vh", sm: "10vh", md: "20vh", lg: "20vh", xl: "20vh" },
    objectFit: "contain",
  },
}
